import type { ProductOffer } from '../../generated/frontend'

export const formatAllRetailers = (offers: ProductOffer[]): ProductOffer[] =>
  offers.filter((offer) => !!offer.url && !!offer.availableInStock)

export const formatRetailers = (offers: ProductOffer[]): ProductOffer[] =>
  formatAllRetailers(offers).slice(0, 3)
